import { NgModule, ModuleWithProviders }                  from '@angular/core';
import { CommonModule }                                   from '@angular/common';
import { MyDatePickerModule }                             from 'mydatepicker';
import { FormsModule }                                    from '@angular/forms';
import { RouterModule }                                   from '@angular/router';
import { UserComponent }                                  from './components/user-add/user.component';
import { UsersListComponent }                             from './components/users-list/user-list.component';
import { AssignRoleComponent }                            from './components/assign-role/assign-role.component';
import { RoleLitsComponent }                              from './components/role-list/role-list.component';
import { RoleEditComponent }                              from './components/role-edit/role-edit.component';
import { RoleAddComponent }                                from './components/role-add/role-add.component';
import { NotificationsMessageComponent }                  from './components/notifications/notifications.component';
import { ProfileEditComponent }                           from './components/profile-edit/profile-edit.component'
import { UserService }                                    from './services/user.service';
import { RoleService }                                    from './services/role.service';
import { SelectModule }                                   from 'ng2-select';
import { MdButtonModule, MdInputModule, MdSelectModule }  from '@angular/material';
import { ModalModule }                                    from 'ng2-bootstrap/modal';
import { ImageCropperComponent, CropperSettings }         from 'ng2-img-cropper';
import { NAV_DROPDOWN_DIRECTIVES }                        from '../shared/nav-dropdown.directive';
import { BsDropdownModule }                               from 'ng2-bootstrap/dropdown';


@NgModule({
  imports: [
    CommonModule,
    MyDatePickerModule,
    FormsModule,
    RouterModule,
    SelectModule,
    MdButtonModule,
    MdInputModule,
    MdSelectModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot()
  ],
  declarations: [
    UserComponent,
    NAV_DROPDOWN_DIRECTIVES,
    RoleLitsComponent,
    RoleEditComponent,
    RoleAddComponent,
    UsersListComponent,
    AssignRoleComponent,
    NotificationsMessageComponent,
    ImageCropperComponent,
    ProfileEditComponent
  ],
  exports: [
    UserComponent,
    RoleLitsComponent,
    RoleEditComponent,
    RoleAddComponent,
    MdSelectModule,
    NotificationsMessageComponent,
    MdInputModule,
    UsersListComponent,
    AssignRoleComponent,
    ProfileEditComponent
  ]
})
export class UserModule {
    static forRoot(): ModuleWithProviders {
      return {
        ngModule: UserModule,
        providers: [
           UserService,
           RoleService
        ]
      };
    }
}



// WEBPACK FOOTER //
// ./src/app/users/user.module.ts